import type { Query, QueryClient } from '@tanstack/react-query';

/**
 * The key `tenantsQueryKeys.byDomain` builds, spelled out: importing the key factory here
 * closes an import cycle through `api/axios`, and the merged `queryKeys` barrel then
 * builds with a piece missing. `AuthProvider.spec` pins the two together.
 */
const isDomainTenant = ({ queryKey: [scope, name] }: Query) =>
  scope === 'tenants' && name === 'byDomain';

/**
 * Everything cached for the account that is leaving, gone. The tenant of this domain stays:
 * it belongs to the site rather than the account, and `api/axios` names every anonymous
 * request's tenant from it. Dropping it sent register and forgot-password with no
 * `X-Tenant-Id`, which the backend reads as the deployment's own tenant.
 */
export function clearAccountCache(queryClient: QueryClient) {
  queryClient.getMutationCache().clear();
  queryClient.removeQueries({
    predicate: (query) => !isDomainTenant(query),
  });
}
